$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  let locationId = $("body").attr("event_id");

  if (p === "text_product_extra") {
    let orderBy = "name";
    let orderByDirection = "asc";
    let status = 1;
    let page = 1;
    $(document).on("submit", "#product-search-form", function (e) {
      e.preventDefault();

      let search_string = $("#search_string").val();
      getTextProductExtraList(
        locationId,
        search_string,
        status,
        orderBy,
        orderByDirection,
        1,
      );
    });

    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();
      page = parseInt($(this).attr("href").substring(6));
      let search_string = $("#search_string").val();
      getTextProductExtraList(
        locationId,
        search_string,
        status,
        orderBy,
        orderByDirection,
        page,
      );
    });

    $(document).on("click", ".sort", function (e) {
      e.preventDefault();

      page = $("#productGroupUnique-table").attr("data-page");
      let search_string = $("#search_string").val();
      orderBy = $(this).attr("data-order-by");
      orderByDirection = $(this).attr("data-order-by-direction");

      getTextProductExtraList(
        locationId,
        search_string,
        status,
        orderBy,
        orderByDirection,
        page,
      );
    });

    function getTextProductExtraList(
      event_id,
      search_string,
      status,
      order_by,
      order_by_direction,
      page,
    ) {
      $.ajax({
        type: "POST",
        url: "/api/v1/private/product-extra/search",
        data: {
          event_id,
          search_string,
          status,
          order_by,
          order_by_direction,
          page,
        },
      })
        .done(function (data) {
          if (data && data.html) {
            $("#text-extra-product-list-view").empty();
            $("#text-extra-product-list-view").html(data.html);
          }
        })
        .fail(function (data) {
          if (data) {
            console.log("fail");
          }
        })
        .always(function () {});
    }
  }
});
